/*
 * @Author: mcdowell
 * @Date: 2021-08-18 19:36:19
 * @LastEditors: mcdowell
 * @LastEditTime: 2021-10-08 14:21:45
 * 
 * 
 * https://guanwang.onelink.me/Boc2/?
    pid=%E5%AE%98%E7%BD%91%E5%AF%BC%E9%87%8F0518
    &c=%E5%AE%98%E7%BD%91&
    af_js_web=true&
    af_channel=weboffice0518_


    AF onelink:https://guanwang.onelink.me/Boc2/71aff14c
    Campaign name=homepage
    Media source=homepage


    https://guanwang.onelink.me/Boc2

    const huaweiLink = `https://appgallery1.huawei.com/#/app/C100418605`;
    let androidLink = `https://www.liveme.com/app/download/apk/liveme.apk`;
    let gpLink = `https://play.google.com/store/apps/details?id=com.europe.live`;
 */
export const getApkUrlbyJsonp = '/app/download/apk/api/getApkUrl.js';
export const androidLink = `/app/download/apk/liveme.apk`;
export const onelink = 'https://guanwang.onelink.me/Boc2';
export const huaweiLink = `https://appgallery1.huawei.com/#/app/C100418605`;
export const gpLink = `https://play.google.com/store/apps/details?id=com.europe.live`;

export const appStoreList = [
  {
    id: 1,
    icon: 'apple_store',
    type: 'apple',
    url: onelink,
    sensorType: 'IOS',
  },
  {
    id: 2,
    icon: 'apk',
    type: 'apk',
    url: androidLink,
    sensorType: 'Android',
  },
  {
    id: 3,
    icon: 'google_store',
    type: 'google',
    url: onelink,
    sensorType: 'gp',
  },
  {
    id: 4,
    icon: 'huawei_store',
    type: 'huawei',
    url: huaweiLink,
    sensorType: 'HuaWei',
  },
];
